import { useCallback, useRef } from "react";

const useDebounce = (callback: Function, delay: number) => {
  const timer = useRef<NodeJS.Timer | null>(null);

  const debouncedWrapper = useCallback(
    (...args: any[]) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return { debouncedWrapper };
};

export default useDebounce;
